<template>
  <div class="page_module_custom_test--edit_test_config_modal">
    <div class="config">
      <div class="row" v-for="row in Object.keys(config)" :key="row">
        <div class="label">{{ row }}</div>
        <div class="textarea-wrap">
          <div class="row">
            <textarea v-model="config[row]"></textarea>
          </div>
        </div>
        <div class="action-btn">
          <div class="button type--info" @click="resumeToDefault(row)">
            <div class="label">{{ $t("button.default") }}</div>
          </div>
          <div class="button type--primary" @click="save(row)">
            <div class="label">{{ $t("button.save") }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Popup from '../../../components/widgets/Popup.vue'
import TemplateInitialData from "@/utils/cp_req_init_data";
import ConfTemplateInitData from "@/utils/cp_conf_init_data";

export default {
  // components: { Popup },
  props: {
    mode: {
      type: Boolean,
      default: false
    },
    whitelist: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  beforeMount() {
    let rows = {};
    if(localStorage.conf_template && this.mode) {
      rows = JSON.parse(localStorage.conf_template);
    }else if(localStorage.request_template && !this.mode) {
      rows = JSON.parse(localStorage.request_template);
    }
    // console.log(rows);
      console.log(this.whitelist)
    Object.keys(rows).map(row=>{
      if(this.whitelist.includes(row) || 1>0) {
        this.config[row] =JSON.stringify(rows[row].data);
      }
    });
  },
  methods: {
    resumeToDefault(key) {
      if(this.mode) {
        let source = ConfTemplateInitData;
      }else {
        let source = TemplateInitialData;
      }
      this.config[key] = JSON.stringify(source[key].data);
      this.$forceUpdate();
    },
    save(key) {
      let value = this.config[key];
      let chkJSON = this.validateJSON(value);
      if(!chkJSON) return;

      if(this.mode) {
        let source = JSON.parse(localStorage.conf_template);
        source[key].data = JSON.parse(value);
        console.log(source);
        localStorage.conf_template = JSON.stringify(source);
      }else {
        let source = JSON.parse(localStorage.request_template);
        source[key].data = JSON.parse(value);
        localStorage.request_template = JSON.stringify(source);
      }

      this.$emit("dataChanged");

      this.$notify({
        title: 'Success',
        message: `[${key}]: saved`,
        position: 'top-left'
      });
    },
    validateJSON(json) {
      let valid = false;
      try{
        JSON.parse(json);
        valid = true;
      }catch(err) {
        this.$notify.error({
          title: 'Error',
          message: 'Invalid JSON format',
          position: 'top-left'
        });
      }
      return valid;
    }
  },
  data() {
    return {
      config: {},
      status: {}
    }
  }
}
</script>

<style lang="scss">
.page_module_custom_test--edit_test_config_modal{
  width: 98vw;
  height: 500px;
  background: white;
  overflow-y: auto;
  .config{
    padding: 10px;
    & > .row{
      display: flex;
      align-items: center;
      & > .label{
        width: 190px;
        margin-right: 5px;
      }
      .textarea-wrap{
        height: 100px;
        width: 100%;
        display: flex;
        .row{
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          textarea{
            flex-grow: 1;
            width: 100%;
            resize: none;
          }
        }
      }
      .action-btn{
        height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        margin-left: 5px;
        button{
          margin-left: 0px;
          &+button{
            margin-top: 5px;
          }
        }
      }
      &:not(:last-child) {
        margin-bottom: 10px;
      }

      .button{
        width: 90px;
        padding: 5px;
        text-align: center;
        border-radius: 3px;
        cursor: pointer;
        user-select: none;
        position: relative;
        &.type--info{
          color: white;
          background-color: #909399;
          border-color: #909399;
        }
        &.type--primary{
          color: white;
          background-color: #409EFF;
          border-color: #409EFF;
        }
        &+.button{
          margin-top: 5px;
        }

        .disabled{
          z-index: 1;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
          background: white;
          opacity: .5;
          cursor: not-allowed;
        }
      }
    }
  }
}
</style>